import { defineComponent as _defineComponent } from 'vue';
import { nextTick, ref, watch } from "vue";
import IntersectionObservable from "./IntersectionObservable.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ListingLayout',
    props: {
        items: null,
        queryKey: null,
        dataKey: null,
        loading: { type: Boolean },
        offset: null
    },
    emits: ["scroll"],
    setup(__props, { emit }) {
        const props = __props;
        const root = ref();
        const currentOffset = ref(0);
        watch(() => currentOffset.value, (offset) => emit("scroll", offset));
        watch(() => props.queryKey, () => {
            root.value?.scrollTo({
                top: 0,
            });
        });
        watch(() => props.offset, async (offset) => {
            await nextTick();
            if (offset !== undefined) {
                scrollToOffset(offset);
            }
        }, { immediate: true });
        function scrollToOffset(offset) {
            const element = root.value?.querySelector(`.listing-layout-item[data-index="${offset}"]`);
            element?.scrollIntoView();
        }
        const observer = new IntersectionObserver((items) => {
            const intersecting = items.filter((item) => item.isIntersecting);
            const indices = intersecting.map((item) => parseInt(item.target.getAttribute("data-index") ?? "0"));
            currentOffset.value = indices.length > 0 ? Math.min(...indices) : 0;
        }, { root: root.value });
        function getKey(item, index) {
            if (props.dataKey) {
                return item[props.dataKey];
            }
            else {
                return index;
            }
        }
        return { __sfc: true, props, emit, root, currentOffset, scrollToOffset, observer, getKey, IntersectionObservable, LoadingSpan };
    }
});
